<template>
    <div class="loader">
        <div class="svg-wrap">
            <svg version="1.1" id="Loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="-2.5 -2.5 49 49">
                <circle class="path_circle" fill="none" stroke="#e3000b" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" cx="22" cy="22" r="22"/>
            </svg>
        </div>
    </div>
</template>

<script>
export default {

    name: 'loader',

}
</script>

<style lang="scss">

.loader{
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width:100%;
    height:100%;
    top:0;
    left:0;
    background: rgba(85, 85, 85, 0.158);
    z-index: 1000;
}

.svg-wrap {
  margin: auto;
  width: 4.4rem;
  height: 4.4rem;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

@keyframes rotator {
	to {
		transform: rotate(360deg);
	}
}

@keyframes loadpath {
  to {
    stroke-dashoffset: -138;
  }
}

div.svg-wrap {
	animation: rotator 1.6s linear infinite forwards;

  circle {
    stroke: #e3000b;
    stroke-dasharray: 138;
    stroke-dashoffset: 138;
    animation: loadpath 1.6s linear infinite forwards;
  }
}
</style>
